import "./Loader.css";

export const Loader = () => {
  return <div className="loader-container flex-center"></div>;
};
